module.exports = __webpack_public_path__ + "static/media/no-property-image.ee8ffcdb.svg";